<template>
    <div class="mt-4" v-if="currentIncident">
        <b-card id="incident-header" header-bg-variant="secondary" header-text-variant="white" no-body class="mb-1">
            <b-card-body v-if="currentIncident">
                <b-card-title>{{ currentIncident.whatHappenned }}
                    <b-button @click="closeIncident" size="sm" class="float-right">Close</b-button>
                </b-card-title>
                <b-card-text>
                    <b>Reported By:</b> {{ currentIncident.initiatedByName }} ({{ currentIncident.initiatedByContact }})
                    <br>
                    <b>Reported On:</b> {{ currentIncident.incidentDateTime | formatLongDateTime }}
                </b-card-text>
                <template #footer>
                    <b-button href="#" variant="primary">Go somewhere</b-button>
                </template>
            </b-card-body>
        </b-card>
        <b-card :header="twilioUserName" v-if="currentIncident" class="stuck-div" ref="stuckDiv">
            <div class="chat-conversation">
                <div data-simplebar>
                    <ul class="conversation-list" ref="conversation">
                        <template v-for="message in conversationList">
                            <li class="clearfix odd" v-if="message.state.author === twilioUserHandle">
                                <div class="chat-avatar">
                                    <img src="@assets/images/users/avatar-1.png" alt="male">
                                    <i>{{ message.state.dateUpdated | formatTime }}</i>
                                </div>
                                <div class="conversation-text">
                                    <div class="ctext-wrap">
                                        <i>{{ message.state.attributes.friendlyName }}</i>
                                        <p>{{ message.state.body }}</p>
                                    </div>
                                </div>
                            </li>
                            <li v-else class="clearfix">
                                <div class="chat-avatar">
                                    <img src="@assets/images/users/avatar-1.png" alt="male">
                                    <i>{{ message.state.dateUpdated | formatTime }}</i>
                                </div>
                                <div class="conversation-text">
                                    <div class="ctext-wrap">
                                        <i>{{ message.state.attributes.friendlyName }}</i>
                                        <p>{{ message.state.body }}</p>
                                    </div>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
            </div> <!-- end .chat-conversation-->
            <div ref="chatform" :style="{ bottom: chatFormBottom }"></div>
            <div class="needs-validation" name="chat-form" id="chat-form">
                <div class="row">
                    <div class="col">
                        <b-form-input class="form-control chat-input" id="message-input" aria-autocomplete="none"
                            @keyup.enter="sendMessage" placeholder="type a message" v-model="newMessage"></b-form-input>
                    </div>
                    <div class="col-auto">
                        <button @click="sendMessage"
                            class="btn btn-danger chat-send w-100 waves-effect waves-light">Send</button>
                    </div>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>

import { Client as ConversationsClient } from "@twilio/conversations"
import pastIncident from "./pastIncident"

import {
    incidentData
} from '@/src/state/api/incident';

import messageSound from '@assets/sound/message-received.mp3';

export default {
    data() {
        return {
            currentDateTime: new Date(),
            newMessage: "",
            conversationList: [],
            currentIncident: null,
            statusString: "",
            isConnected: false,
            conversationsClient: null,
            twilioUserName: null,
            twilioUserHandle: null,
            twilioUser: null,
            conversationHandle: null,
            activeConversation: null,
            initialViewportHeight: window.innerHeight,
            chatFormBottom: '0px'
        }
    },
    components: {
        pastIncident
    },
    computed: {
        locationId() {
            return this.$route.params.locationId;
        },
        incidentId() {
            return this.$route.params.incidentId;
        },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
    },
    async created() {
        this.twilioUserHandle = this.$store.getters.loggedInUser.mobile;
        this.twilioUserName = this.$store.getters.loggedInUser.name;
        await this.loadIncident();
        await this.setupTokenForUser();
        await this.setupTwilioUser();
    },
    methods: {
        handleResize() {
            if (window.innerHeight < this.initialViewportHeight) {
                // Keyboard is open
                this.chatFormBottom = `${this.initialViewportHeight - window.innerHeight}px`;
            } else {
                // Keyboard is closed
                this.chatFormBottom = '0px';
            }
        },
        async loadIncident() {
            if (!this.incidentId) {
                return;
            }

            this.currentIncident = await incidentData.searchMyIncidentByKey(this.incidentId);
            if (this.currentIncident) {
                this.conversationHandle = this.currentIncident.incidentHandle
            }
        },
        setupTokenForUser: async function () {
            window.conversationsClient = ConversationsClient
            const result = await incidentData.generateToken(this.twilioUserHandle)
            if (!result.succeeded) {
                return;
            }

            this.conversationsClient = new ConversationsClient(result.data.token)
            this.statusString = "Connecting to Twilio…"
            this.conversationsClient.on("connectionStateChanged", (state) => {
                switch (state) {
                    case "connected":
                        this.statusString = "You are connected."
                        this.isConnected = true
                        break
                    case "disconnecting":
                        this.statusString = "Disconnecting from Twilio…"
                        break
                    case "disconnected":
                        this.statusString = "Disconnected."
                        break
                    case "denied":
                        this.statusString = "Failed to connect."
                        break
                }
            })
        },
        setupTwilioUser: async function () {
            if (this.conversationsClient) {
                this.twilioUser = await this.conversationsClient.getUser(this.twilioUserHandle)
                this.activeConversation = await this.conversationsClient.getConversationByUniqueName(this.currentIncident.id)
                await this.activeConversation.getMessages()
                    .then((newMessages) => {
                        this.conversationList = [...this.conversationList, ...newMessages.items]
                        this.scrollToElement()
                    })

                this.activeConversation.on("messageAdded", (newMessage) => {
                    this.conversationList = [...this.conversationList, newMessage]
                    this.scrollToElement()
                    new Audio(messageSound).play();
                })
            }
        },
        selectedIncident(incident) {
            this.currentIncident = incident;
        },
        async closeIncident() {

            if (!confirm("Are you sure you want to close this incident?")) {
                return;
            }

            var payload = {
                incidentId: this.currentIncident.id,
                RequestDateTime: new Date(),
            }

            var result = await incidentData.closeIncident(payload);
            if (!result.succeeded) {
                this.$vs.notify({
                    title: "Error",
                    text: result.message,
                    color: "danger",
                    position: "top-center"
                });
                return;
            }

            this.$vs.notify({
                title: "Success",
                text: "Incident Closed.",
                color: "success",
                position: "top-center"
            });
        },
        sendMessage() {
            if (!this.newMessage) {
                return;
            }

            this.activeConversation.sendMessage(this.newMessage, {
                friendlyName: this.twilioUserName
            })
                .then(async () => {

                    var payload = {
                        incidentId: this.currentIncident.id,
                        newMessage: this.newMessage,
                        senderName: this.twilioUserName
                    }

                    await incidentData.whenIncidentMessageAdded(payload);

                    this.newMessage = ""
                    this.scrollToElement()
                })
        },
        scrollToElement() {
            this.$nextTick(() => {
                const stuckDiv = this.$refs.chatform;
                if (stuckDiv) {
                    stuckDiv.scrollIntoView({ behavior: 'smooth' });
                }
            });
        }
    }
}
</script>

<style>
#incident-header {
    position: sticky;
    top: 0;
    z-index: 1000;
}

#chat-form {
    position: fixed;
    left: 0;
    bottom: 60px;
    width: 100%;
    background-color: #dddddd;
    color: white;
    text-align: center;
    padding: 10px;
}

.stuck-div {
    height: auto;
    overflow-y: auto;
}

/* #chat-form:focus-within {
    bottom: 300px;
} */
</style>